import React, { Children, cloneElement } from 'react'
import Grid from './Grid'

const GridSingles = ({ title = undefined, errorMsgState = undefined, children, disabled = false }) => {


    return (
        <Grid
            title={title}
            gridTemplateColumnsCss={"100%"}
            disabled={disabled}
            errorMsgState={errorMsgState}
        >
            {children}
        </Grid>
    )
}

export default GridSingles